export default "__VITE_ASSET__VlsuFkTu__"